import {
  AssociatedProperty,
  IAssociatedProperty,
} from '@app/models/AssociatedProperty'
import { Record } from 'immutable'
import { Assignment, IAssignment } from './Assignment'
import { SignTranferStatus } from './enums'
import { ISignType, SignType } from './SignType'

export interface ISignTransfer {
  readonly assignment: IAssignment
  readonly assignmentId: string
  readonly from: IAssociatedProperty
  readonly id: string
  readonly quantity: number
  readonly signId: string
  readonly signType: ISignType
  readonly status: SignTranferStatus
  readonly to?: IAssociatedProperty
}

const SignTransferRecord = Record({
  assignment: new Assignment(),
  assignmentId: '',
  from: new AssociatedProperty(),
  id: '',
  quantity: 0,
  signId: '',
  signType: new SignType(),
  status: SignTranferStatus.Incomplete,
  to: undefined,
})

export class SignTransfer extends SignTransferRecord implements ISignTransfer {
  public static fromJS(initialState?: Partial<ISignTransfer>) {
    if (!initialState) {
      return new SignTransfer()
    }

    const { assignment, from, signType, to, ...rest } = initialState

    return new SignTransfer({
      assignment: Assignment.fromJS(assignment),
      from: AssociatedProperty.fromJS(from),
      signType: SignType.fromJS(signType),
      to: to ? AssociatedProperty.fromJS(to) : undefined,
      ...rest,
    })
  }

  public readonly assignment: IAssignment
  public readonly assignmentId: string
  public readonly from: IAssociatedProperty
  public readonly id: string
  public readonly quantity: number
  public readonly signId: string
  public readonly signType: ISignType
  public readonly status: SignTranferStatus
  public readonly to?: IAssociatedProperty

  constructor(props?: Partial<SignTransfer>) {
    props ? super(props) : super()
  }
}
